import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  signal,
  untracked,
  ViewChildren,
  viewChildren,
  input,
  viewChild,
  QueryList,
} from '@angular/core';
import { Subject, Subscription, firstValueFrom } from 'rxjs';
import { APIService } from 'src/app/services/APIService/api.service';
import { OverlayService } from 'src/app/services/Overlay/overlay.service';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { MangelMediaApiFuncService } from 'src/app/services/MediaApiFunc/mangel-media-api-func.service';
import { DeselectSingleSelectedDirective } from 'src/app/directives/deselect-single-selected.directive';
import { DynamicStyleDirective } from 'src/app/directives/dynamic-style.directive';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { BasicStoreService } from 'src/app/services/BasicStore/basic-store.service';
import {
  MediaViewModalComponent,
  TitleAndFileNames,
} from '../../_components/_shared/mediaviewmodal/mediaviewmodal.component';
import { DetailviewComponent } from '../../_components/detailview/detailview.component';
import { previewMap } from '../../_components/detailview/previewMap';
import { ProgressbarComponent } from '../../_components/progressbar/progressbar.component';
import { NewauftragmodalComponent } from '.././newauftragmodal/newauftragmodal.component';
import { CommonModule } from '@angular/common';
import { ClarityModule, ClrDatagrid, ClrDatagridColumn } from '@clr/angular';
import {
  ColumnFilterAction,
  ColumnFilterApplied,
  ColumnFilterComponent,
} from '../../_components/filter/column-filter/column-filter.component';
import { Row, Table } from 'src/app/models/ui/table';
import { BackendLocaleDatePipe } from 'src/app/pipes/get-locale-date.pipe';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { ColumnHideManService } from 'src/app/services/Shared/colhidemanager.service';
import { FILTER_TABLE_STORE, provideFilterStore } from 'src/app/shared/stores/filter-table.store';
import { FilterItem } from 'src/app/models/ui/filter';
import { GetByCallbackPipe } from 'src/app/pipes/get-by-callback.pipe';
import { rxResource, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Base64Service } from 'src/app/services/base64/base64.service';
import { ToastService } from 'src/app/services/toast.service';
import { IconDgCellComponent } from '../../_components/_shared/datagrid-cell/icon-dg-cell.component';
import { errorHandle, getTokenRight } from 'src/app/misc/functions';
import { AuftragMangelStore, savedToAuftrag } from '../../_components/_overlays/auftrag-detail/auftrag-mangel.store';
import { Events } from '@ngrx/signals/events';
import { GeometryCollection } from 'geojson';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-auftragsliste',
  templateUrl: './auftragsliste.component.html',
  styleUrls: ['./auftragsliste.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    NewauftragmodalComponent,
    DetailviewComponent,
    ProgressbarComponent,
    ColumnFilterComponent,
    MediaViewModalComponent,
    DynamicStyleDirective,
    DeselectSingleSelectedDirective,
    IconDgCellComponent,
    HideIDColumnsPipe,
    MrTranslatePipe,
    GetByCallbackPipe,
  ],
  providers: [provideFilterStore({ storage: 'auftraege' })],
})
export class AuftragsListeComponent implements OnDestroy, OnInit {
  private basicStore = inject(BasicStoreService);
  private apiservice = inject(APIService);
  private spinnerservice = inject(SpinnerService);
  private overlayService = inject(OverlayService);
  protected media = inject(MangelMediaApiFuncService);
  protected localeDate = inject(BackendLocaleDatePipe);
  private colHideService = inject(ColumnHideManService);
  protected authService = inject(AuthService);

  private readonly base64service = inject(Base64Service);
  private readonly toastr = inject(ToastService);
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly mangelStore = inject(AuftragMangelStore);
  protected readonly filterStore = inject(FILTER_TABLE_STORE);

  readonly viewType = input<string>(undefined);

  private readonly columnFilters = viewChildren(ColumnFilterComponent);
  private readonly objDg = viewChild<ClrDatagrid>('objDg');
  private readonly auftrDg = viewChild<ClrDatagrid>('auftrDg');
  private readonly scrollContainer = computed(() => this.auftrDg()?.datagridTable);
  private rights;
  public allowCreate: boolean;

  @ViewChildren(ClrDatagridColumn) columns: QueryList<ClrDatagridColumn>;
  @ViewChildren(ClrDatagridColumn) columnsObj: QueryList<ClrDatagridColumn>;
  @ViewChildren(ClrDatagridColumn) columnsMang: QueryList<ClrDatagridColumn>;

  protected readonly origAuftraege = signal<Table>({ rows: [], columns: [] });
  protected readonly auftraege = computed(() => {
    const { columns, rows } = this.origAuftraege();
    switch (this.viewType()) {
      case 'rueckmelden':
        return { columns, rows: rows.filter(row => row.WFStatus == 4) };
      case 'genehmigen':
        return { columns, rows: rows.filter(row => row.WFStatus == 2) };
      default:
        return { columns, rows };
    }
  });

  // * Alle zu filternden Objekte und Mängel
  private objekte = {
    rows: [] as Row[],
    columns: [],
  };

  private maengel = {
    rows: [] as Row[],
    columns: [],
  };

  // * Alle zu filternden Mängel mit ausgewähltem kauftrid
  private mnglAllAuftrag: any[];

  // * Angezeigte und gefilterte Objekte und Mängel
  protected objTable = {
    rows: [] as Row[],
    columns: [],
  };

  protected mnglTable = {
    rows: [] as Row[],
    columns: [],
  };

  private _selectedAuftrag: any;
  protected get selectedAuftrag() {
    return this._selectedAuftrag;
  }
  protected set selectedAuftrag(auftrag) {
    this._selectedAuftrag = auftrag;
    const kauftrid = auftrag?.auftrag;
    this.objTable.rows = [];
    this.objDg()?.selection.clearSelection();
    if (kauftrid) {
      // * In ObjektTable in Template filtern objekte mit dieser Auftragnummer
      this.objTable.rows = this.objekte.rows.filter((obj: any) => obj.auftragid == kauftrid);
      // * In MangelTable in Template filtern mängel mit dieser Auftragnummer
      this.mnglAllAuftrag = this.maengel.rows.filter((mngl: any) => mngl.auftragid == kauftrid);

      if (this.objTable.rows?.length && this.mnglAllAuftrag?.length) {
        setTimeout(() => {
          const objDg = this.objDg();
          if (objDg) {
            objDg.selection.current = this.objTable.rows;
          }
        });
      }
    }
  }

  private _selectedObjects: Row[] = [];
  protected get selectedObjects() {
    return this._selectedObjects;
  }
  protected set selectedObjects(newObjs: Row[]) {
    this._selectedObjects = newObjs;
    const ostammids = newObjs.map(newObj => newObj.ostammid);
    if (ostammids?.length && this.mnglAllAuftrag?.length) {
      this.mnglTable.rows = this.mnglAllAuftrag.filter(mngl => ostammids.indexOf(mngl.ostammid) != -1);
    } else this.mnglTable.rows = [];
    // this.objDg?.dataChanged();
  }

  private _ostammid: number = undefined;
  protected get ostammid() {
    return this._ostammid;
  }
  protected set ostammid(val: number) {
    this.showdetailview = !!val;
    this._ostammid = val;
  }

  showoverlay: boolean = false;
  showdetailview: boolean = false;
  hidedetailview: boolean = false;
  showprogressbar: boolean = false;
  map: any;
  showGIS: boolean = false;
  formatDBName: string = localStorage.getItem('FormatCurDB').replace('_', ' ');
  hides = ['firmaid', 'bezirk', 'stellwerk', 'kostenart', 'gruppenid', 'gruppenname', 'wfstatus'];
  hidesobj = ['kauftsid', 'auftragid', 'bezirk', 'stellwerk'];
  hidesmang = ['kauftmid', 'kauftsid', 'auftragid', 'bezirk', 'stellwerk', 'bild', 'rueckbilder'];

  split50 = false;
  sidenavenlarged = false;
  progressbarenlarged = false;
  progressbars: any;
  componentStore: any = {};

  indexScrub: number = -1;

  private destroyed$ = new Subject<void>();

  private readonly dataRefresh = new Subject<void>();
  reloadTabsIsReady = new Subject();

  mangelMedia: TitleAndFileNames[];
  protected readonly isNewAuftragModalOpen = signal(false);

  optInterface: number = -1;
  protected colFname: string = 'Auftrag';

  protected readonly abnahmeDropdownID = signal<number>(undefined);
  private readonly abnahmenNames = rxResource({
    params: () => this.abnahmeDropdownID(),
    stream: ({ params }) => this.apiservice.getAbnahmenProtokolls(params),
  });

  protected readonly abnahmeLoading = this.abnahmenNames.isLoading;
  protected readonly abnahmen = computed(() => this.abnahmenNames.value());

  constructor() {
    inject(Events)
      .on(savedToAuftrag)
      .pipe(takeUntilDestroyed())
      .subscribe({ ...this.dataRefresh, next: _ => this.dataRefresh.next() });

    this.dataRefresh.pipe(takeUntilDestroyed()).subscribe(() => this.reloadTabs());

    this.filterStore.registerTable(this.auftraege);
    this.filterStore.registerFilters(this.columnFilters);
    this.filterStore.onRedirect(filter => this.setFilterTerminFromDashboard(filter));
  }

  ngOnInit(): void {
    this.spinnerservice.enable();
    this.componentStore = this.basicStore.getComponentStore('auftraege');
    this.rights = JSON.parse(this.authService.decrypt(localStorage.getItem('rights')));
    this.allowCreate = getTokenRight(this.rights.program, 'AllowPAuftrCreate');

    if (!this.componentStore?.auftraege?.rows?.length || !this.componentStore.maengel?.rows?.length) {
      this.loadAuftraege();
    } else {
      setTimeout(() => {
        if (this.componentStore.auftraege.rows.length) this.origAuftraege.set(this.componentStore.auftraege);

        if (this.componentStore.maengel?.rows?.length) {
          this.maengel = this.componentStore.maengel;
          this.mnglTable.columns = this.maengel.columns;
        }

        if (this.componentStore.objekte?.rows?.length) {
          this.objekte = this.componentStore.objekte;
          this.objTable.columns = this.objekte.columns;
        }
        this.restoreSelection();

        setTimeout(() => this.spinnerservice.disable());
      });
    }

    var colInfo = JSON.parse(localStorage.getItem('ColInfo'));
    if (colInfo && colInfo.Auftrag.auftraege) this.hides = this.hides.concat(colInfo.Auftrag.auftraege.split(','));
    if (colInfo && colInfo.Auftrag.objekte) this.hidesobj = this.hidesobj.concat(colInfo.Auftrag.objekte.split(','));
    if (colInfo && colInfo.Auftrag.maengel) this.hidesmang = this.hidesmang.concat(colInfo.Auftrag.maengel.split(','));
  }

  restoreSelection() {
    setTimeout(() => {
      const selAuft = this.selectedAuftrag ?? this.componentStore?.selectedAuftrag;
      if (!selAuft || !this.auftrDg()) return;

      const all = this.filterStore.filteredRows();
      const ind = all.findIndex(item => item.auftrag == selAuft.auftrag);
      this.auftrDg().virtualScroll.scrollToIndex(ind);

      setTimeout(() => {
        this.auftrDg().selected = [all[ind]];
        const objDg = this.objDg();
        if (this.componentStore?.selectedObjects?.length && objDg) {
          let ostammidsSelected = this.componentStore.selectedObjects.map(selObj => selObj.ostammid);
          objDg.selected = objDg.items.all.filter(item => ostammidsSelected.indexOf(item.ostammid) != -1);
        }
      }, 10);
    }, 5);
  }

  restoreOpened() {
    const openedAuftrag = this.mangelStore.auftragId();
    if (!openedAuftrag) return;
    const rows = this.maengel.rows.filter(row => row.auftragid == openedAuftrag);
    this.mangelStore.saveReloadedMangel(rows);
  }

  removeColFilter() {
    this.colHideService.removeColHide(this.colFname + '.auftraege');
    this.hides = ['firmaid', 'bezirk', 'stellwerk', 'kostenart', 'gruppenid', 'gruppenname'];
  }
  removeColFilterObj() {
    this.colHideService.removeColHide(this.colFname) + '.objekte';
    this.hidesobj = ['kauftsid', 'auftragid', 'bezirk', 'stellwerk'];
  }
  removeColFilterMang() {
    this.colHideService.removeColHide(this.colFname + '.maengel');
    this.hidesmang = ['kauftmid', 'kauftsid', 'auftragid', 'bezirk', 'stellwerk', 'bild', 'rueckbilder'];
  }
  columnHiddenChange(event) {
    this.colHideService.columnHiddenChange(this.columns).then((x: string[]) => (this.hides = x));
  }
  columnHiddenChangeObj() {
    this.colHideService.columnHiddenChange(this.columnsObj).then((x: string[]) => (this.hidesobj = x));
  }
  columnHiddenChangeMang() {
    this.colHideService.columnHiddenChange(this.columnsMang).then((x: string[]) => (this.hidesmang = x));
  }

  setFilterTerminFromDashboard({ columnId }: ColumnFilterApplied) {
    if (columnId != 'termin') return;

    effect(() => {
      const termins = this.filterStore.uniqueValues()['termin'];
      if (termins?.size)
        untracked(() => {
          const now = Date.parse(BackendLocaleDatePipe.now);
          const items: FilterItem[] = [...termins].flatMap((termin: string) =>
            Date.parse(termin) < now ? [{ name: termin }] : []
          );
          this.filterStore.onChange({
            columnId,
            items,
            reason: ColumnFilterAction.Submit,
          });
        });
    });
  }

  protected async loadAuftraege() {
    this.optInterface = +this.authService.decrypt(localStorage.getItem('optInterface'));

    const objekte = await firstValueFrom(this.apiservice.getAuftraegeObjekteAll());
    this.objekte = objekte;
    this.objTable.columns = objekte.columns;

    const maengel = await firstValueFrom(this.apiservice.getAuftraegeMaengelAll());
    this.maengel = maengel;
    this.mnglTable.columns = maengel.columns;

    const auftraege = await firstValueFrom(this.apiservice.getAuftraege());
    this.basicStore.resetComponentStore('auftraege', { auftraege });

    this.origAuftraege.set(auftraege);

    this.restoreSelection();
    this.restoreOpened();

    setTimeout(() => this.spinnerservice.disable());
  }

  protected reloadTabs() {
    this.basicStore.reloadTabs({ reloadAnlagen: false });
    this.loadAuftraege();
  }

  protected scroll() {
    if (this.selectedAuftrag) {
      const kauftrid = this.selectedAuftrag.auftrag;
      this.scrollContainer()
        .nativeElement.querySelector('#a-' + kauftrid)
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
    }
  }

  protected previewMap(mangel: Row, objekt: Row) {
    this.showGIS = true;
    mangel.baseVon = objekt?.StartMeter || 0;
    setTimeout(() => {
      this.map = previewMap(mangel, objekt?.geometry, this.map);
    });
  }

  protected getObjektByMangel = (row: Row) => this.objTable.rows?.find(el => el.ostammid == row.ostammid);

  protected getGeometryType = (row: Row) => (row.geometry as GeometryCollection)?.type;

  protected openAuftrag(row: any) {
    this.mangelStore.openedAuftrag(+row.auftrag);

    let auftrag = {
      Titel: row.titel,
      Firma: row.firma,
      ['Termin Anfang']: row.termins,
      ['Termin Ende']: row.termin,
      Auftragsart: row.auftragart,
      Auftragsnummer: row.auftragnummer,
      Kostenart: row.kostenart,
      Bemerkung: row.bemerkung,
      Auftragsstatus: row.erlstatus,
      wfStatus: row.WFStatus,
      Gruppe: row.gruppenid,
      inforJOBNUM: null,
      inforACTIVITYCODE: null,
      inforClosed: null,
      Ursache: null,
      Störgrund: null,
      Störbeginn: null,
      Störende: null,
      Festgestellt: null,
    };

    if (this.optInterface == 3) {
      auftrag.inforJOBNUM = row.inforJOBNUM;
      auftrag.inforACTIVITYCODE = row.inforACTIVITYCODE;
      auftrag.inforClosed = row.inforClosed;
      auftrag.Ursache = row.Ursache;
      auftrag.Störgrund = row.Störgrund;
      auftrag.Störbeginn = row.Störbeginn;
      auftrag.Störende = row.Störende;
      auftrag.Festgestellt = row.Festgestellt;
    }

    this.overlayService.setOverlay({
      overlay: 'auftragDetail',
      data: {
        id: Number(row.auftrag),
        maengel: {
          rows: this.maengel.rows.filter(mngl => mngl.auftragid == row.auftrag),
          columns: this.maengel.columns,
        },
        objekte: {
          rows: this.objekte.rows.filter(obj => obj.auftragid == row.auftrag),
          columns: this.objekte.columns,
        },
        auftrag,
      },
      dataRefresh: this.dataRefresh,
    });
  }

  protected openPDF(kauftrid: any) {
    this.spinnerservice.enable();
    this.apiservice
      .getAuftragPDF(parseInt(kauftrid.auftrag))
      .pipe()
      .subscribe(val => {
        this.spinnerservice.disable();
        this.overlayService.setOverlay({
          overlay: 'viewAuftrag',
          data: val,
          auftragsnr: kauftrid.auftrag,
          zIndex: 5,
        });
      });
  }

  protected openPdfMangel(file: File) {
    this.mangelMedia = undefined;
    this.overlayService.setOverlay({
      overlay: 'viewAuftrag',
      isTopOverlay: true,
      data: {
        data: file,
        titel: file?.name || 'Datei',
        file: file?.name + '.pdf',
      },
      zIndex: 5,
    });
  }

  protected async openAbnahmePDF(id: number) {
    try {
      const base64 = await firstValueFrom(this.apiservice.getAbnahmeProtokoll(id));
      const data = this.base64service.convertFileAsBlob(base64, 'application/pdf', 'Abnahme');
      if (data)
        this.overlayService.setOverlay({
          overlay: 'viewAuftrag',
          isTopOverlay: true,
          data: {
            data,
            titel: 'Abnahme anzeigen',
          },
        });
    } catch (error) {
      this.toastr.error(errorHandle(error));
    }
  }

  ngOnDestroy() {
    this.basicStore.setComponentStore('auftraege', {
      auftraege: this.origAuftraege(),
      objekte: this.objekte,
      maengel: this.maengel,
      selectedAuftrag: this.selectedAuftrag,
      selectedObjects: this.selectedObjects,
    });

    var cols = {
      auftraege: this.columns
        .toArray()
        .filter(x => x.isHidden)
        .map(x => x.field.toLowerCase())
        .join(','),
      objekte: this.columnsObj
        .toArray()
        .filter(x => x.isHidden)
        .map(x => x.field.toLowerCase())
        .join(','),
      maengel: this.columnsMang
        .toArray()
        .filter(x => x.isHidden)
        .map(x => x.field.toLowerCase())
        .join(','),
    };
    var colInfo = localStorage.getItem('ColInfo') ? JSON.parse(localStorage.getItem('ColInfo')) : Object.create(null);
    colInfo.Auftrag = cols;
    localStorage.setItem('ColInfo', JSON.stringify(colInfo));

    this.destroyed$.next();
    this.mangelStore.openedAuftrag(null);
  }

  protected enlargeSidenav(event) {
    if (event.mode == 'full') {
      this.sidenavenlarged = event.val;
    } else if (event.mode == 'half') {
      this.split50 = event.val;
    } else if (event.mode == 'progress') {
      this.showprogressbar = event.val;
      this.progressbars = {};
    } else if (event.mode == 'hidden') {
      this.hidedetailview = event.val;
    } else if (event.mode == 'close') {
      this.ostammid = undefined;
      this.showprogressbar = false;
      setTimeout(() => {
        this.showdetailview = false;
      });
    }
  }

  protected handleScrub(event) {
    this.indexScrub = event;
  }

  protected showProgressData(data) {
    if (data) {
      this.progressbars = data;
      this.showprogressbar = true;
    }
  }

  protected enlargeProgressbar(val?) {
    if (val) {
      this.progressbarenlarged = true;
    } else {
      this.progressbarenlarged = !this.progressbarenlarged;
    }
  }

  protected normalizedId(id: string): string {
    return id.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-_]/g, '');
  }
}
